import React from 'react';
import { Link } from 'react-router-dom';
import { topics as topicsData } from '../data/topics';
import { trackTopicClick } from '../services/gtmService';

const TopicsGrid = () => {
  const topics = Object.entries(topicsData).map(([key, topic]) => ({
    name: topic.title.replace(' Questions', ''),
    path: topic.path,
    icon: topic.icon,
    description: topic.description,
    color: topic.color,
  }));

  const handleTopicClick = (topicName, topicPath) => {
    trackTopicClick(topicName, topicPath);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
      {topics.map((topic, index) => (
        <Link
          key={topic.path}
          to={topic.path}
          onClick={() => handleTopicClick(topic.name, topic.path)}
          className="group block bg-white rounded-2xl shadow-lg hover:shadow-2xl overflow-hidden hover:shadow-orange-200/50 active:scale-95"
        >
          <div className="h-2 bg-gradient-to-r from-green-700 to-emerald-600 group-hover:h-3 transition-all duration-300"></div>
          <div className="p-5 sm:p-8">
            <div className="text-4xl sm:text-6xl mb-3 sm:mb-4">
              {topic.icon}
            </div>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2 sm:mb-3 group-hover:text-orange-600 transition-colors duration-300">
              {topic.name}
            </h2>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
              {topic.description}
            </p>
            <div className="mt-4 sm:mt-6 flex items-center text-orange-600 font-semibold text-sm sm:text-base">
              <span>Explore Questions</span>
              <span className="ml-2 group-hover:translate-x-2 transition-transform duration-300">→</span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default TopicsGrid;
